import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { Farm } from "../types/logisticsTypes.ts"

export const getFarms = async (): Promise<Farm[]> => {
  const res = await authFetch(`${API_BASE}/logistics/farms/`)
  const data: Farm[] = await res.json()
  return data
}
